module.exports = __webpack_public_path__ + "./img/OfertasCreacion.ffef7c5134c013bb1c3d36c3f14940fd.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/Help/OfertasCreacion.png
// module id = ./public/img/Help/OfertasCreacion.png
// module chunks = 0